/*
 * @Description: 支付审核
 * @Date: 2022-12-09 10:11:37
 */
import fields from './fields';
import search from './search';
import TableRenderClass from '@/components/tableRender/tableRenderClass';
import { paymentReview } from '@/api/ajax';
import {
  bankRowLabelFiled,
  bankSearchFiled,
  payTypeRowLabelFiled,
  payTypeSearchFiled
} from '@/common/fields/bank'; // 在这混入兼容方便兼容之前数据
import { PAY_BANK_TYPE_KEY, PAY_TYPE_KEY } from '@/common/constants/bank';
let example = new TableRenderClass({ fields, search });

const reviewedTableColumn = example.createPart({
  name: '待审核',
  search: [
    'orderNo',
    'projectNameSelect',
    'industryIdSelect',
    'supplierIdSelect',
    bankSearchFiled,
    payTypeSearchFiled,
    'tiJiaoAudit'
  ],
  list: paymentReview.list,
  defaultQuery: { auditStatus: 1 },
  requestNow: true,
  fields: [
    'index',
    'orderNo',
    'projectName',
    'industryName1',
    'supplierName',
    'daizhifudingdanshengchengshijian',
    'pagMentpayDt',
    'zhifuSumPrice',
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'auditStatus',
    {
      label: '支付状态',
      prop: 'payStatus',
      formatter(r) {
        return ['待支付', '支付中', '部分支付成功', '支付成功', '支付失败'][
          r.payStatus
        ];
      }
    },
    'auditOperation'
  ]
});
const auditTableColumn = example.createPart({
  name: '已审核',
  search: [
    'orderNo',
    'projectNameSelect',
    'industryIdSelect',
    'paymentState',
    'aspAuditStatusSelect',
    'supplierIdSelect',
    bankSearchFiled,
    payTypeSearchFiled,
    'aspAuditDt'
  ],
  list: paymentReview.list,
  defaultQuery: { auditStatus: 2 },
  requestNow: true,
  fields: [
    'index',
    'orderNo',
    'projectName',
    'industryName1',
    'supplierName',
    'daizhifudingdanshengchengshijian',
    'aspAuditDt',
    'zhifuSumPrice',
    bankRowLabelFiled[PAY_BANK_TYPE_KEY],
    payTypeRowLabelFiled[PAY_TYPE_KEY],
    'auditStatus',
    {
      label: '支付状态',
      prop: 'payStatus',
      formatter(r) {
        return ['待支付', '支付中', '部分支付成功', '支付成功', '支付失败'][
          r.payStatus
        ];
      }
    }
  ]
});
export default {
  name: '订单审核',
  childMenu: [reviewedTableColumn, auditTableColumn]
};
